import { Injectable } from '@angular/core';

import { SearchResult } from '../model/search/search-result';
import { ContentfulService } from './contentful.service';

@Injectable({
  providedIn: 'root'
})
export class PageContentSearchService {
  public cachedSearchResults: SearchResult[] = [];

  public totalResult = 0;

  private searchTitles: any[] = [];
  public searchTitleUrlmap = new Map();
  constructor(private contentfulService: ContentfulService) {}
  async fetchSearchResultsFromContentful(): Promise<void> {
    if (this.cachedSearchResults.length === 0) {
      try {
        this.cachedSearchResults = await this.contentfulService.getSearchResults();

        this.totalResult = this.cachedSearchResults.length;
      } catch (error) {
        throw 'Error fetching search result from contentful';
      }
    }
  }
  returnAllContentfulSearchResults(): SearchResult[] {
    let searchResult: SearchResult[] = [];
    this.cachedSearchResults.forEach((searchResultItem: any) => {
      if (searchResultItem && searchResultItem.fields && searchResultItem.fields.searchResultTitle && searchResultItem.fields.url && searchResultItem.fields.searchableText) {
        this.searchTitles.push(searchResultItem.fields.searchResultTitle);
        this.getUrl(searchResultItem);
        const searchResultLines = searchResultItem.fields.searchableText.split('\n');
        searchResultLines.forEach((searchLine: string) => {
          searchResultItem.fields.searchResultLine = searchLine;
        });
        searchResult.push(searchResultItem.fields);
        this.getSortedArray(searchResult);
        this.searchTitleUrlmap.set(searchResultItem.fields.searchResultTitle, searchResultItem.fields.urlWithoutHost);
      }
    });
    return searchResult;
  }

  getSearchResults(searchText: string): SearchResult[] {
    const searchTextLower = searchText.toLowerCase();
    let titleSearches: SearchResult[] = [];
    let tagSearches: SearchResult[] = [];
    let exactTitleMatch: SearchResult[] = [];
    let contentSearches: SearchResult[] = [];
    let finalResult: SearchResult[] = [];
    let resultIndex = 0;
    this.cachedSearchResults.forEach((searchResultItem: any) => {
      if (searchResultItem.fields && searchResultItem.fields.searchResultTitle) {
        if (searchResultItem.fields.searchResultTitle.toLowerCase() === searchTextLower) {
          this.getUrl(searchResultItem);
          let searchResult: SearchResult = searchResultItem.fields;
          const searchResultLines = searchResultItem.fields.searchResultTitle.split('\n');
          searchResultLines.forEach((searchLine: string | undefined) => {
            if (searchLine && searchLine.toLowerCase().includes(searchTextLower)) {
              searchResult.searchResultLine = searchLine;
            }
          });
          exactTitleMatch.push(searchResult);
        } else if (searchResultItem.fields.searchResultTitle.toLowerCase().includes(searchTextLower)) {
          this.getUrl(searchResultItem);
          let searchResult: SearchResult = searchResultItem.fields;
          const searchResultLines = searchResultItem.fields.searchResultTitle.split('\n');
          searchResultLines.forEach((searchLine: string | undefined) => {
            if (searchLine && searchLine.toLowerCase().includes(searchTextLower)) {
              searchResult.searchResultLine = searchLine;
            }
          });
          titleSearches.push(searchResult);
        }
      }

      if (searchResultItem.fields && searchResultItem.fields.searchableTags) {
        const searchTags = searchResultItem.fields.searchableTags;
        searchTags.forEach((searchTag: any) => {
          let matchingResult = this.getSimilarText(searchTextLower, searchTag.tag);
          if (searchTag && !searchResultItem.fields.searchResultLine && matchingResult) {
            this.getUrl(searchResultItem);
            let searchResult: SearchResult = searchResultItem.fields;
            searchResult.searchResultLine = searchTag.tag;
            tagSearches.push(searchResult);
          }
        });
      }

      if (searchResultItem.fields && searchResultItem.fields.searchableText && searchResultItem.fields.searchableText.toLowerCase().includes(searchTextLower)) {
        this.getUrl(searchResultItem);
        let searchResult: SearchResult = searchResultItem.fields;
        const searchResultLines = searchResultItem.fields.searchableText.split('\n');
        searchResultLines.forEach((searchLine: string | undefined) => {
          if (searchLine && searchLine.toLowerCase().includes(searchTextLower)) {
            searchResult.searchResultLine = searchLine;
          }
        });
        contentSearches.push(searchResult);
      }
      resultIndex++;

      if (resultIndex > this.totalResult - 1) {
        this.getSortedArray(contentSearches);
        this.getSortedArray(exactTitleMatch);
        this.getSortedArray(titleSearches);
        this.getSortedArray(tagSearches);
        contentSearches.unshift(...tagSearches);
        contentSearches.unshift(...titleSearches);
        contentSearches.unshift(...exactTitleMatch);

        let exactMatch: SearchResult[] = [];
        contentSearches.forEach((content) => {
          if (content && content.searchResultTitle && content.searchResultTitle.toLowerCase().startsWith(searchTextLower)) {
            exactMatch.push(content);
          }
        });
        contentSearches.unshift(...exactMatch);

        const searchMap = new Map();
        contentSearches.forEach((content) => {
          if (typeof content.searchResultTitle !== 'undefined' && typeof content.searchableText !== 'undefined') {
            let resultData = content.searchResultTitle + content.searchableText;
            searchMap.set(resultData, content);
          }
        });
        searchMap.forEach((content) => {
          finalResult.push(content);
        });
      }
    });
    return finalResult;
  }

  private getUrl(searchResultItem: { fields: any }) {
    let host = window.location.protocol + '//' + window.location.host;
    if (searchResultItem.fields.url && !searchResultItem.fields.url.includes(host)) {
      let decodedUrl = decodeURI(searchResultItem.fields.url);
      searchResultItem.fields.urlWithoutHost = decodedUrl;
      searchResultItem.fields.url = host + decodedUrl;
    }
  }

  private getSimilarText(searchText: string, searchableText: string): string | undefined {
    if (typeof searchText !== 'undefined') {
      const searchWords = searchText.split(' ');
      if (typeof searchableText !== 'undefined') {
        const searchableWords = searchableText.toLowerCase().split(' ');
        let matchingWords: any[] = [];
        for (const searchWord of searchWords) {
          if (searchableWords.includes(searchWord)) {
            matchingWords.push(...searchableWords.filter((word: string) => word === searchWord));
            return matchingWords.join(' ');
          }
        }
      }
    }
    return undefined;
  }

  private getSortedArray(resultedArray: SearchResult[]) {
    resultedArray.sort(function (a, b) {
      if (a.searchResultTitle && b.searchResultTitle && a.searchResultTitle.toLowerCase() < b.searchResultTitle.toLowerCase()) {
        return -1;
      }
      return 1;
    });
  }

  getSearchResultTitle(): string[] {
    return this.searchTitles;
  }
}
